// extracted by mini-css-extract-plugin
module.exports = {"drawerSectionTitleRoot":"styles_drawerSectionTitleRoot__omA5D"};